import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import settings from './settings'
import user from './user'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})
Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  modules: {
    settings, user
  },
  plugins: [vuexLocal.plugin]
})



// WEBPACK FOOTER //
// ./src/store/index.js